import { render, staticRenderFns } from "./appSendLimit.vue?vue&type=template&id=53885700"
import script from "./appSendLimit.vue?vue&type=script&lang=js"
export * from "./appSendLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports